module.exports = __webpack_public_path__ + "img/198.2d3fdb5d.jpg";